export default __webpack_public_path__ + "static/media/active-challenge.d2f0430f.svg";